var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.825 1.8H10.125V0.675C10.125 0.2925 9.8325 0 9.45 0H4.5C4.1175 0 3.825 0.2925 3.825 0.675V1.8H1.125C0.495 1.8 0 2.295 0 2.925V16.875C0 17.505 0.495 18 1.125 18H12.825C13.455 18 13.95 17.505 13.95 16.875V2.925C13.95 2.295 13.455 1.8 12.825 1.8ZM5.175 1.35H8.775V3.15H5.175V1.35ZM5.715 14.625H3.735C3.3525 14.625 3.06 14.3325 3.06 13.95C3.06 13.5675 3.3525 13.275 3.735 13.275H5.715C6.0975 13.275 6.39 13.5675 6.39 13.95C6.39 14.3325 6.0975 14.625 5.715 14.625ZM10.215 11.25H3.735C3.3525 11.25 3.06 10.9575 3.06 10.575C3.06 10.1925 3.3525 9.9 3.735 9.9H10.215C10.5975 9.9 10.89 10.1925 10.89 10.575C10.89 10.9575 10.5975 11.25 10.215 11.25ZM10.215 7.875H3.735C3.3525 7.875 3.06 7.5825 3.06 7.2C3.06 6.8175 3.3525 6.525 3.735 6.525H10.215C10.5975 6.525 10.89 6.8175 10.89 7.2C10.89 7.5825 10.5975 7.875 10.215 7.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIcon);
export default __webpack_public_path__ + "static/media/orderIcon.e767fb15ccc700cf74786c859e0a42c3.svg";
export { ForwardRef as ReactComponent };